//* External
import PropTypes from 'prop-types';

//* App Custom
import { tnl } from '@i18nApp/i18n';
import './Wizard.scss';

const Wizard = ({ current, steps }) => {
  const wizardActives = steps.map((_, i) => current >= i);

  return (
    <div className="w-100 d-flex gap-3 justify-content-center">
      {wizardActives.map((isActive, i) => (
        <div
          key={i}
          className={`wizard ${isActive ? 'wizard-active' : 'wizard-deactive'}`}
        >
          {tnl(steps[i])}
        </div>
      ))}
    </div>
  );
};

Wizard.propTypes = {
  current: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string)
};

export default Wizard;
